import React from "react";

export const MoveToFolderIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_1076_6251"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1076_6251)">
      <path
        d="M9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V7C3 6.71667 3.09583 6.47917 3.2875 6.2875C3.47917 6.09583 3.71667 6 4 6C4.28333 6 4.52083 6.09583 4.7125 6.2875C4.90417 6.47917 5 6.71667 5 7V20H15C15.2833 20 15.5208 20.0958 15.7125 20.2875C15.9042 20.4792 16 20.7167 16 21C16 21.2833 15.9042 21.5208 15.7125 21.7125C15.5208 21.9042 15.2833 22 15 22H5Z"
        fill="white"
      />
    </g>
  </svg>
);

export const ChatIcon = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M8.01996 4.23231L7.02689 2.30307C6.64381 1.55886 6.45228 1.18676 6.19496 1.0662C5.97094 0.961234 5.71185 0.961234 5.48783 1.0662C5.23051 1.18676 5.03897 1.55886 4.6559 2.30306L3.66283 4.23231C3.59646 4.36124 3.56327 4.42571 3.52035 4.48264C3.48224 4.53318 3.4385 4.57921 3.38998 4.61984C3.33531 4.66562 3.27262 4.70204 3.14725 4.7749L3.14724 4.7749L1.15859 5.93051C0.506999 6.30915 0.181203 6.49847 0.0716652 6.74524C-0.0238884 6.96051 -0.0238884 7.20616 0.0716652 7.42142C0.181203 7.6682 0.506999 7.85752 1.15859 8.23616L3.14724 9.39176C3.27262 9.46462 3.33531 9.50105 3.38998 9.54682C3.4385 9.58746 3.48224 9.63349 3.52035 9.68402C3.56327 9.74095 3.59646 9.80542 3.66283 9.93436L4.6559 11.8636C5.03897 12.6078 5.23051 12.9799 5.48783 13.1005C5.71185 13.2054 5.97094 13.2054 6.19496 13.1005C6.45228 12.9799 6.64381 12.6078 7.02689 11.8636L8.01996 9.93436C8.08633 9.80542 8.11951 9.74095 8.16244 9.68402C8.20055 9.63349 8.24429 9.58746 8.29281 9.54682C8.34748 9.50105 8.41017 9.46462 8.53555 9.39176L10.5242 8.23616C11.1758 7.85752 11.5016 7.6682 11.6111 7.42142C11.7067 7.20616 11.7067 6.96051 11.6111 6.74524C11.5016 6.49847 11.1758 6.30915 10.5242 5.93051L8.53555 4.7749C8.41017 4.70205 8.34748 4.66562 8.29281 4.61984C8.24429 4.57921 8.20055 4.53318 8.16244 4.48264C8.11951 4.42571 8.08633 4.36124 8.01996 4.23231Z"
      fill={fill}
    />
    <path
      d="M12.7373 11.312L12.0577 12.1615C11.8462 12.4259 11.7405 12.558 11.7009 12.7104C11.666 12.8445 11.666 12.9889 11.7009 13.1229C11.7405 13.2753 11.8462 13.4075 12.0577 13.6718L12.7373 14.5213C12.9487 14.7857 13.0545 14.9178 13.1764 14.9673C13.2836 15.0109 13.3992 15.0109 13.5064 14.9673C13.6283 14.9178 13.734 14.7857 13.9455 14.5213L14.6251 13.6718C14.8366 13.4075 14.9423 13.2753 14.9819 13.1229C15.0168 12.9889 15.0168 12.8445 14.9819 12.7104C14.9423 12.558 14.8366 12.4259 14.6251 12.1615L13.9455 11.312C13.734 11.0477 13.6283 10.9155 13.5064 10.866C13.3992 10.8224 13.2836 10.8224 13.1764 10.866C13.0545 10.9155 12.9487 11.0477 12.7373 11.312Z"
      fill={fill}
    />
    <path
      d="M13.0393 0.191467L12.6995 0.531279C12.5938 0.637008 12.5409 0.689872 12.5211 0.750832C12.5037 0.804453 12.5037 0.862214 12.5211 0.915835C12.5409 0.976794 12.5938 1.02966 12.6995 1.13539L13.0393 1.4752C13.1451 1.58093 13.1979 1.63379 13.2589 1.6536C13.3125 1.67102 13.3703 1.67102 13.4239 1.6536C13.4849 1.63379 13.5377 1.58093 13.6434 1.4752L13.9833 1.13539C14.089 1.02966 14.1419 0.976794 14.1617 0.915835C14.1791 0.862214 14.1791 0.804453 14.1617 0.750832C14.1419 0.689872 14.089 0.637008 13.9833 0.531279L13.6434 0.191467C13.5377 0.0857384 13.4849 0.0328739 13.4239 0.013067C13.3703 -0.00435566 13.3125 -0.00435566 13.2589 0.013067C13.1979 0.0328739 13.1451 0.0857384 13.0393 0.191467Z"
      fill={fill}
    />
  </svg>
);

export const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M5.35714 7.14286H0.892857C0.639881 7.14286 0.427827 7.05729 0.256696 6.88616C0.0855655 6.71503 0 6.50298 0 6.25C0 5.99702 0.0855655 5.78497 0.256696 5.61384C0.427827 5.44271 0.639881 5.35714 0.892857 5.35714H5.35714V0.892857C5.35714 0.639881 5.44271 0.427827 5.61384 0.256696C5.78497 0.0855655 5.99702 0 6.25 0C6.50298 0 6.71503 0.0855655 6.88616 0.256696C7.05729 0.427827 7.14286 0.639881 7.14286 0.892857V5.35714H11.6071C11.8601 5.35714 12.0722 5.44271 12.2433 5.61384C12.4144 5.78497 12.5 5.99702 12.5 6.25C12.5 6.50298 12.4144 6.71503 12.2433 6.88616C12.0722 7.05729 11.8601 7.14286 11.6071 7.14286H7.14286V11.6071C7.14286 11.8601 7.05729 12.0722 6.88616 12.2433C6.71503 12.4144 6.50298 12.5 6.25 12.5C5.99702 12.5 5.78497 12.4144 5.61384 12.2433C5.44271 12.0722 5.35714 11.8601 5.35714 11.6071V7.14286Z"
      fill="#EAF7FF"
    />
  </svg>
);

export const PreviewIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none">
  <path d="M9.275 7.125C9.85833 6.54167 10.15 5.83333 10.15 5C10.15 4.16667 9.85833 3.45833 9.275 2.875C8.69167 2.29167 7.98333 2 7.15 2C6.31667 2 5.60833 2.29167 5.025 2.875C4.44167 3.45833 4.15 4.16667 4.15 5C4.15 5.83333 4.44167 6.54167 5.025 7.125C5.60833 7.70833 6.31667 8 7.15 8C7.98333 8 8.69167 7.70833 9.275 7.125ZM5.875 6.275C5.525 5.925 5.35 5.5 5.35 5C5.35 4.5 5.525 4.075 5.875 3.725C6.225 3.375 6.65 3.2 7.15 3.2C7.65 3.2 8.075 3.375 8.425 3.725C8.775 4.075 8.95 4.5 8.95 5C8.95 5.5 8.775 5.925 8.425 6.275C8.075 6.625 7.65 6.8 7.15 6.8C6.65 6.8 6.225 6.625 5.875 6.275ZM3.075 8.8C1.84722 8 0.877778 6.94444 0.166667 5.63333C0.111111 5.53333 0.0694444 5.43056 0.0416667 5.325C0.0138889 5.21944 0 5.11111 0 5C0 4.88889 0.0138889 4.78056 0.0416667 4.675C0.0694444 4.56944 0.111111 4.46667 0.166667 4.36667C0.877778 3.05556 1.84722 2 3.075 1.2C4.30278 0.4 5.66111 0 7.15 0C8.63889 0 9.99722 0.4 11.225 1.2C12.4528 2 13.4222 3.05556 14.1333 4.36667C14.1889 4.46667 14.2306 4.56944 14.2583 4.675C14.2861 4.78056 14.3 4.88889 14.3 5C14.3 5.11111 14.2861 5.21944 14.2583 5.325C14.2306 5.43056 14.1889 5.53333 14.1333 5.63333C13.4222 6.94444 12.4528 8 11.225 8.8C9.99722 9.6 8.63889 10 7.15 10C5.66111 10 4.30278 9.6 3.075 8.8ZM10.6083 7.675C11.6583 7.01389 12.4611 6.12222 13.0167 5C12.4611 3.87778 11.6583 2.98611 10.6083 2.325C9.55833 1.66389 8.40556 1.33333 7.15 1.33333C5.89444 1.33333 4.74167 1.66389 3.69167 2.325C2.64167 2.98611 1.83889 3.87778 1.28333 5C1.83889 6.12222 2.64167 7.01389 3.69167 7.675C4.74167 8.33611 5.89444 8.66667 7.15 8.66667C8.40556 8.66667 9.55833 8.33611 10.6083 7.675Z" fill="#71717A"/>
</svg>
);

export const RenameIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
  <path d="M1.26036 13.864C0.913764 13.864 0.617053 13.7406 0.370232 13.4938C0.123411 13.2469 0 12.9502 0 12.6036C0 12.257 0.123411 11.9603 0.370232 11.7135C0.617053 11.4667 0.913764 11.3433 1.26036 11.3433H11.3433C11.6899 11.3433 11.9866 11.4667 12.2334 11.7135C12.4802 11.9603 12.6036 12.257 12.6036 12.6036C12.6036 12.9502 12.4802 13.2469 12.2334 13.4938C11.9866 13.7406 11.6899 13.864 11.3433 13.864H1.26036ZM2.52073 8.82255H3.40298L8.3184 3.92288L7.42039 3.02487L2.52073 7.94029V8.82255ZM1.26036 9.45273V7.67246C1.26036 7.58844 1.27612 7.50704 1.30763 7.42827C1.33914 7.3495 1.3864 7.2786 1.44942 7.21558L8.3184 0.362355C8.43393 0.246821 8.56785 0.157545 8.72014 0.0945273C8.87243 0.0315091 9.03261 0 9.20065 0C9.3687 0 9.5315 0.0315091 9.68904 0.0945273C9.84659 0.157545 9.98838 0.252073 10.1144 0.378109L10.9809 1.26036C11.107 1.3759 11.1989 1.51244 11.2566 1.66998C11.3144 1.82753 11.3433 1.99032 11.3433 2.15837C11.3433 2.31592 11.3144 2.47084 11.2566 2.62313C11.1989 2.77543 11.107 2.91459 10.9809 3.04063L4.12769 9.89385C4.06467 9.95687 3.99378 10.0041 3.915 10.0356C3.83623 10.0672 3.75483 10.0829 3.67081 10.0829H1.89055C1.71199 10.0829 1.56233 10.0225 1.44154 9.90173C1.32076 9.78095 1.26036 9.63128 1.26036 9.45273Z" fill="#71717A"/>
</svg>
);

export const DownloadIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
  <path d="M5.08333 7.675C5.00556 7.64722 4.93333 7.6 4.86667 7.53333L2.46667 5.13333C2.33333 5 2.26944 4.84444 2.275 4.66667C2.28056 4.48889 2.34444 4.33333 2.46667 4.2C2.6 4.06667 2.75833 3.99722 2.94167 3.99167C3.125 3.98611 3.28333 4.05 3.41667 4.18333L4.66667 5.43333V0.666667C4.66667 0.477778 4.73056 0.319444 4.85833 0.191667C4.98611 0.0638889 5.14444 0 5.33333 0C5.52222 0 5.68056 0.0638889 5.80833 0.191667C5.93611 0.319444 6 0.477778 6 0.666667V5.43333L7.25 4.18333C7.38333 4.05 7.54167 3.98611 7.725 3.99167C7.90833 3.99722 8.06667 4.06667 8.2 4.2C8.32222 4.33333 8.38611 4.48889 8.39167 4.66667C8.39722 4.84444 8.33333 5 8.2 5.13333L5.8 7.53333C5.73333 7.6 5.66111 7.64722 5.58333 7.675C5.50556 7.70278 5.42222 7.71667 5.33333 7.71667C5.24444 7.71667 5.16111 7.70278 5.08333 7.675ZM1.33333 10.6667C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V8C0 7.81111 0.0638889 7.65278 0.191667 7.525C0.319444 7.39722 0.477778 7.33333 0.666667 7.33333C0.855556 7.33333 1.01389 7.39722 1.14167 7.525C1.26944 7.65278 1.33333 7.81111 1.33333 8V9.33333H9.33333V8C9.33333 7.81111 9.39722 7.65278 9.525 7.525C9.65278 7.39722 9.81111 7.33333 10 7.33333C10.1889 7.33333 10.3472 7.39722 10.475 7.525C10.6028 7.65278 10.6667 7.81111 10.6667 8V9.33333C10.6667 9.7 10.5361 10.0139 10.275 10.275C10.0139 10.5361 9.7 10.6667 9.33333 10.6667H1.33333Z" fill="#71717A"/>
</svg>
);

export const DeleteIcon = ({ className }) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

export const SpinnerIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
);

export const ColumnIcon = ({ className }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="12" y1="3" x2="12" y2="21"></line>
  </svg>
);

export const SelectedFolderIcon = ({ className }) => (
  <svg
    className="ml-2 flex-shrink-0"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#A259FF"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

export const OpenFolderIcon = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

export const ConflictsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
  <path d="M14.017 1.45999C12.9227 -0.486663 10.0769 -0.486663 8.9826 1.45999L0.362252 16.8062C-0.695882 18.6899 0.690866 21 2.87943 21H20.1209C22.3095 21 23.6963 18.6899 22.6373 16.8062L14.017 1.45999ZM12.5267 16.1536C12.5267 16.4213 12.4185 16.6782 12.2259 16.8675C12.0333 17.0569 11.7721 17.1632 11.4998 17.1632C11.2274 17.1632 10.9662 17.0569 10.7736 16.8675C10.581 16.6782 10.4729 16.4213 10.4729 16.1536C10.4729 15.8858 10.581 15.629 10.7736 15.4396C10.9662 15.2503 11.2274 15.1439 11.4998 15.1439C11.7721 15.1439 12.0333 15.2503 12.2259 15.4396C12.4185 15.629 12.5267 15.8858 12.5267 16.1536ZM11.4998 5.65296C11.7177 5.65296 11.9266 5.73806 12.0807 5.88954C12.2348 6.04102 12.3213 6.24647 12.3213 6.4607V12.9226C12.3213 13.1368 12.2348 13.3423 12.0807 13.4938C11.9266 13.6453 11.7177 13.7304 11.4998 13.7304C11.2819 13.7304 11.0729 13.6453 10.9189 13.4938C10.7648 13.3423 10.6782 13.1368 10.6782 12.9226V6.4607C10.6782 6.24647 10.7648 6.04102 10.9189 5.88954C11.0729 5.73806 11.2819 5.65296 11.4998 5.65296Z" fill="#E21919"/>
</svg>
);

export const GapIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M0 11.5C0 5.14855 5.14855 0 11.5 0C17.8514 0 23 5.14855 23 11.5C23 17.8514 17.8514 23 11.5 23C5.14855 23 0 17.8514 0 11.5ZM10.3592 8.0293C10.6098 7.79701 10.9236 7.64426 11.261 7.59037C11.5985 7.53648 11.9443 7.58388 12.2547 7.72655C12.5652 7.86923 12.8264 8.10079 13.0052 8.39193C13.1841 8.68307 13.2726 9.02071 13.2595 9.36215V9.38975C13.2563 9.61031 13.209 9.828 13.1205 10.03C13.032 10.2321 12.904 10.4144 12.7441 10.5663C12.5842 10.7182 12.3955 10.8366 12.1891 10.9146C11.9828 10.9926 11.763 11.0286 11.5425 11.0204C11.3881 11.0147 11.2341 11.0402 11.0897 11.0954C10.9453 11.1505 10.8135 11.2342 10.7021 11.3415C10.5908 11.4487 10.5023 11.5773 10.4418 11.7195C10.3813 11.8618 10.35 12.0147 10.35 12.1693V13.8C10.35 14.105 10.4712 14.3975 10.6868 14.6132C10.9025 14.8288 11.195 14.95 11.5 14.95C11.805 14.95 12.0975 14.8288 12.3132 14.6132C12.5288 14.3975 12.65 14.105 12.65 13.8V13.1802C13.4742 12.9539 14.203 12.4669 14.7273 11.7919C15.2515 11.1169 15.5431 10.2903 15.5583 9.43575C15.5972 8.36825 15.2105 7.32903 14.4831 6.5467C13.7558 5.76437 12.7475 5.30301 11.68 5.26412C10.6125 5.22524 9.57326 5.612 8.79092 6.33934C8.00859 7.06668 7.54724 8.075 7.50835 9.1425C7.49676 9.4475 7.6068 9.74461 7.81428 9.96847C8.02175 10.1923 8.30965 10.3246 8.61465 10.3362C8.91965 10.3478 9.21676 10.2377 9.44062 10.0303C9.66448 9.8228 9.79676 9.5349 9.80835 9.2299C9.82445 8.7722 10.0223 8.3398 10.3592 8.0293ZM11.4885 16.1092C11.1835 16.1092 10.891 16.2304 10.6753 16.446C10.4597 16.6617 10.3385 16.9542 10.3385 17.2592C10.3385 17.5642 10.4597 17.8567 10.6753 18.0724C10.891 18.288 11.1835 18.4092 11.4885 18.4092H11.5C11.805 18.4092 12.0975 18.288 12.3132 18.0724C12.5288 17.8567 12.65 17.5642 12.65 17.2592C12.65 16.9542 12.5288 16.6617 12.3132 16.446C12.0975 16.2304 11.805 16.1092 11.5 16.1092H11.4885Z" fill="#F0C000"/>
</svg>
);


export const StaleAssetIcon = ({ className }) => (
<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
  <path d="M11.25 0C17.4634 0 22.5 5.03663 22.5 11.25C22.5 17.4634 17.4634 22.5 11.25 22.5C5.03663 22.5 0 17.4634 0 11.25C0 5.03663 5.03663 0 11.25 0ZM11.25 4.5C10.9516 4.5 10.6655 4.61853 10.4545 4.8295C10.2435 5.04048 10.125 5.32663 10.125 5.625V11.25C10.1251 11.5483 10.2436 11.8344 10.4546 12.0454L13.8296 15.4204C14.0418 15.6253 14.326 15.7387 14.621 15.7361C14.9159 15.7336 15.1981 15.6153 15.4067 15.4067C15.6153 15.1981 15.7336 14.9159 15.7361 14.621C15.7387 14.326 15.6253 14.0418 15.4204 13.8296L12.375 10.7843V5.625C12.375 5.32663 12.2565 5.04048 12.0455 4.8295C11.8345 4.61853 11.5484 4.5 11.25 4.5Z" fill="black" fillOpacity="0.5"/>
</svg>
);

export const ArrowIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
  <path d="M4.46183 6L0.293893 1.80269C0.0979644 1.60538 0 1.35426 0 1.04933C0 0.744395 0.0979644 0.493274 0.293893 0.295964C0.489822 0.0986547 0.739186 0 1.04198 0C1.34478 0 1.59415 0.0986547 1.79008 0.295964L6.70611 5.24664C6.81298 5.35426 6.88868 5.47085 6.93321 5.59641C6.97774 5.72197 7 5.8565 7 6C7 6.1435 6.97774 6.27803 6.93321 6.40359C6.88868 6.52915 6.81298 6.64574 6.70611 6.75336L1.79008 11.704C1.59415 11.9013 1.34478 12 1.04198 12C0.739186 12 0.489822 11.9013 0.293893 11.704C0.0979644 11.5067 0 11.2556 0 10.9507C0 10.6457 0.0979644 10.3946 0.293893 10.1973L4.46183 6Z" fill="black" fillOpacity="0.5"/>
</svg>
  );

  export const FilterIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M5.85049 13.3333C5.61438 13.3333 5.41646 13.2535 5.25674 13.0938C5.09702 12.934 5.01716 12.7361 5.01716 12.5V7.5L0.183824 1.33333C-0.0245098 1.05556 -0.0557598 0.763889 0.0900735 0.458333C0.235907 0.152778 0.489379 0 0.85049 0H12.5172C12.8783 0 13.1317 0.152778 13.2776 0.458333C13.4234 0.763889 13.3922 1.05556 13.1838 1.33333L8.35049 7.5V12.5C8.35049 12.7361 8.27063 12.934 8.11091 13.0938C7.95118 13.2535 7.75327 13.3333 7.51716 13.3333H5.85049ZM6.68382 6.91667L10.8088 1.66667H2.55882L6.68382 6.91667Z" fill="#52525B"/>
</svg>
    );
  
 

//     import React from "react";

// // Spinner icon
// export const SpinnerIcon = () => (
//   <svg className="animate-spin" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
//   </svg>
// );

// Check icon
export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

// Clock icon
export const ClockIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

// Error icon
export const ErrorIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
);

// Document icon
export const DocumentIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

// White document icon
export const WhiteDocumentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

// Sort icon
export const SortIcon = () => (
  <svg className="text-gray-400 group-hover:text-gray-700" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 15l5 5 5-5" />
    <path d="M7 9l5-5 5 5" />
  </svg>
);

// Three dots menu icon
export const ThreeDotsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="3" viewBox="0 0 12 3" fill="none">
    <path d="M1.39895 2.22795C1.01424 2.22795 0.684902 2.11888 0.410941 1.90072C0.13698 1.68257 0 1.42032 0 1.11398C0 0.807633 0.13698 0.545385 0.410941 0.327231C0.684902 0.109077 1.01424 0 1.39895 0C1.78366 0 2.11299 0.109077 2.38695 0.327231C2.66092 0.545385 2.7979 0.807633 2.7979 1.11398C2.7979 1.42032 2.66092 1.68257 2.38695 1.90072C2.11299 2.11888 1.78366 2.22795 1.39895 2.22795ZM5.59579 2.22795C5.21108 2.22795 4.88174 2.11888 4.60778 1.90072C4.33382 1.68257 4.19684 1.42032 4.19684 1.11398C4.19684 0.807633 4.33382 0.545385 4.60778 0.327231C4.88174 0.109077 5.21108 0 5.59579 0C5.9805 0 6.30984 0.109077 6.5838 0.327231C6.85776 0.545385 6.99474 0.807633 6.99474 1.11398C6.99474 1.42032 6.85776 1.68257 6.5838 1.90072C6.30984 2.11888 5.9805 2.22795 5.59579 2.22795ZM9.79263 2.22795C9.40792 2.22795 9.07859 2.11888 8.80463 1.90072C8.53067 1.68257 8.39369 1.42032 8.39369 1.11398C8.39369 0.807633 8.53067 0.545385 8.80463 0.327231C9.07859 0.109077 9.40792 0 9.79263 0C10.1773 0 10.5067 0.109077 10.7806 0.327231C11.0546 0.545385 11.1916 0.807633 11.1916 1.11398C11.1916 1.42032 11.0546 1.68257 10.7806 1.90072C10.5067 2.11888 10.1773 2.22795 9.79263 2.22795Z" fill="#8B55DD" />
  </svg>
);
export const ViewIngestIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <path d="M4 7V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-5" />
    <path d="M2 15h10" />
    <path d="m9 12 3 3-3 3" />
  </svg>
);

export const RemoveFromFolderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M1.36 3.65c0-.58.47-.8.8-.8h3.13c.12 0 .24.05.33.13l1.2 1.32h6.02c.44 0 .8.36.8.8v6.25c0 .44-.36.8-.8.8H2.16a.8.8 0 0 1-.8-.8V3.65z"
      stroke="#71717A"
      strokeWidth="1.1"
      strokeLinejoin="round"
    />
    <path d="M5.3 8.2h4.4" stroke="#71717A" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

export const MoveFolderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  <path d="M5.2793 2.34961C5.45528 2.34963 5.62623 2.38561 5.79102 2.45508H5.79199C5.95442 2.52464 6.09597 2.61785 6.21484 2.73535L7.26953 3.77832H12.834C13.2028 3.7784 13.5188 3.9026 13.7715 4.15234C14.0244 4.40251 14.1509 4.71647 14.1504 5.08301V11.3467C14.1503 11.713 14.0238 12.0263 13.7715 12.2764C13.5192 12.5264 13.2033 12.6498 12.834 12.6494V12.6504H2.16699C1.79762 12.6504 1.48093 12.526 1.22852 12.2764C0.97622 12.0267 0.850146 11.7127 0.849609 11.3457V3.6543C0.849609 3.28739 0.976434 2.97337 1.22949 2.72363C1.48212 2.47452 1.79775 2.35017 2.16602 2.34961H5.2793ZM2.16699 3.36426C2.07247 3.36428 2.00523 3.3928 1.95312 3.44434C1.9011 3.4958 1.87242 3.56232 1.87207 3.65527V11.3467C1.87212 11.4387 1.90117 11.5043 1.95312 11.5557C2.00507 11.6069 2.07201 11.6357 2.16699 11.6357H12.834C12.9282 11.6357 12.9949 11.6069 13.0469 11.5557C13.0988 11.5043 13.1279 11.4387 13.1279 11.3467V5.08203C13.1279 4.98994 13.0989 4.92446 13.0469 4.87305C12.9949 4.82172 12.9282 4.79304 12.834 4.79297H6.85742L6.81348 4.75L5.49219 3.44434C5.47546 3.4278 5.45938 3.41516 5.44434 3.40527L5.39941 3.38281C5.36655 3.37065 5.33147 3.36426 5.29395 3.36426H2.16699ZM7.64844 5.98047C7.78192 5.98694 7.90042 6.03737 7.99512 6.13086L9.58594 7.7041C9.72872 7.84535 9.80458 8.01738 9.80469 8.21387C9.80469 8.41047 9.72859 8.58288 9.58594 8.72461V8.72559L7.99609 10.2979C7.89624 10.3974 7.77433 10.4557 7.63477 10.4551C7.49591 10.4544 7.37381 10.3965 7.27344 10.2979C7.16963 10.1958 7.11293 10.0687 7.12012 9.92383C7.12677 9.79037 7.17865 9.67285 7.27344 9.5791L8.13965 8.72168H5.47168C5.33239 8.72161 5.20834 8.67332 5.10938 8.57617C5.03451 8.50264 4.9879 8.41427 4.96973 8.31543L4.96094 8.21387C4.9616 8.07446 5.0106 7.95023 5.10938 7.85254C5.20822 7.7548 5.33296 7.70705 5.47266 7.70703H8.14062L7.27344 6.84961C7.17312 6.75032 7.11354 6.62884 7.11426 6.48926C7.11498 6.35093 7.17422 6.23067 7.27344 6.13184C7.37652 6.02925 7.50384 5.97357 7.64844 5.98047Z" fill="#71717A" stroke="#71717A" strokeWidth="0.3"/>
</svg>
);